import React from 'react';
import ErrorPopUp from './ErrorPopUp'; // adjust the path if needed
import { useErrorPopup } from './ErrorPopupContext'; // adjust the path if needed

const ErrorPopUpDialog = () => {
  const { errorMessage, hideError } = useErrorPopup();

  return (
    <ErrorPopUp
      open={Boolean(errorMessage)}  // true if errorMessage exists, else false
      onClose={hideError}
      message={errorMessage || ''}
    />
  );
};

export default ErrorPopUpDialog;
